<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('clients.api_keys.edit_secret')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <el-form :model="form" :rules="rules" ref="ruleForm" class="flex flex-col pt-4 px-4 w-full" @submit.native.prevent="apply('ruleForm')">
        <div class="lg:mb-2 flex flex-row items-center">
          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600">{{$t('clients.api_keys.expiration_date')}}</label>
        </div>
        <div class="lg:mb-2">
          <el-form-item prop="fecha">
            <el-date-picker v-if="dialogOpen" class="bg-white dark:bg-darkblue-900"
              v-model="form.fecha" type="date" :picker-options="dateRangeOptions" popper-class="!z-[2020]"
              :format="datePattern"  value-format="yyyy-MM-dd[T00:00:00]" placeholder="" :loading="isGeneralLoading">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </template>
    <template slot="footer">
      <div class="flex flex-row gap-2 w-full">
        <base-button-responsive @click="toggleDialog" mode="secondary-phantom-blue" icon="check" class="flex-1 w-full" :text="$t('app.cancel')" :loading="isGeneralLoading"/>
        <base-button-responsive @click="apply('ruleForm')" icon="plus" mode="secondary-phantom-blue" class="flex-1 w-full" :text="$t('invoices.invoices_issuing.step0.modal_continue')" :loading="isGeneralLoading"/>
      </div>
    </template>
  </base-dialog>
</template>

<script>

import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default
{
  name: 'user-edit-apikey-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      form: this.getDefaultForm(),
      isOpen: this.dialogOpen,
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.dateOptions
      },
      rules: {
        fecha: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      this.form = this.getDefaultForm()
      if (value) {
        this.form.fecha = this.row.NoFormatDate
      } 
    },
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    getDefaultForm: function () {
      return {
        fecha: new Date()
      }
    },
    dateOptions: function (date) {
      if (date !== undefined || date !== null) {
        return date < Date.parse(this.row.NoFormatDate)
      }
    },
    apply: function (formName) {
      try {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            this.toggleDialog()
            this.$emit('applyDialog', this.row, this.form.fecha)
          }
        })
      } catch (error) {
        // this.doFeedback()
      }
    },
  }
}
</script>

<style></style>
